import { Component, OnInit } from '@angular/core';
import { SeoService } from '@app/core/seo/seo.service';

@Component({
    standalone: false,
    selector: 'app-ws-terms',
    templateUrl: './ws-terms.component.html'
    // .legal styles are global (styles.scss imports pages/legal.scss) so the prerendered shell matches
})
export class WsTermsComponent implements OnInit {
    constructor(private seo: SeoService) { }

    ngOnInit(): void {
        this.seo.set({
            title: 'Terms of service',
            description: 'Terms of service for the ESZES website and the free Snapcart local edition of BMS: licence, acceptable use, warranties and liability.',
            path: '/terms'
        });
    }
}
